import { Component } from '@angular/core';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: false
})
export class MaintenanceComponent {
  logoPath1: string = 'assets/img/sony_logo_white.svg';
  logoPath2: string = 'assets/img/logo.svg';
  readonly currentYear: number = new Date().getFullYear();
  constructor() {}

}
